import { httpClient } from '../httpClient';
import {
  IImageGeneration,
  CreateImageGenerationRequest,
  UpdateImageGenerationRequest,
  PaginatedResponse,
  ImageGenerationQuery,
  PaginationQuery,
  CreateSubjectImageGenerationRequest,
  CreateSubjectImageEditRequest
} from '@packages/global';

/**
 * 用户图片生成 API 模块
 * 处理用户图片生成管理操作
 */
export class ImageGenerationApi {
  /**
   * 获取用户图片生成分页列表（POST，强类型）
   */
  async imageGenerationPageList(queryData: PaginationQuery<ImageGenerationQuery>): Promise<PaginatedResponse<IImageGeneration>> {
    return httpClient.post<PaginatedResponse<IImageGeneration>>('/user/imageGenerations/page', queryData);
  }

  /**
   * 创建图片生成任务
   */
  async createImageGeneration(data: CreateImageGenerationRequest): Promise<IImageGeneration> {
    return httpClient.post<IImageGeneration>('/user/imageGenerations', data);
  }

  /**
   * 获取图片生成任务详情
   */
  async getImageGeneration(id: string): Promise<IImageGeneration> {
    return httpClient.get<IImageGeneration>(`/user/imageGenerations/${id}`);
  }

  /**
   * 更新图片生成任务
   */
  async updateImageGeneration(id: string, data: UpdateImageGenerationRequest): Promise<IImageGeneration> {
    return httpClient.put<IImageGeneration>(`/user/imageGenerations/${id}`, data);
  }

  /**
   * 取消图片生成任务
   */
  async cancelImageGeneration(id: string): Promise<void> {
    return httpClient.post<void>(`/user/imageGenerations/${id}/cancel`);
  }

  /**
   * 删除图片生成任务
   */
  async deleteImageGeneration(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/imageGenerations/${id}`);
  }

  /**
   * 创建主体图生成任务（文生图）
   * 根据主体类型（角色/道具/场景）智能生成合适的图片
   */
  async createSubjectImageGeneration(data: CreateSubjectImageGenerationRequest): Promise<IImageGeneration> {
    return httpClient.post<IImageGeneration>('/user/imageGenerations/subject', data);
  }

  /**
   * 创建主体图编辑任务（图生图）
   * 基于参考图生成主体设定图，支持布局修改和风格转换
   */
  async createSubjectImageEdit(data: CreateSubjectImageEditRequest): Promise<IImageGeneration> {
    return httpClient.post<IImageGeneration>('/user/imageGenerations/subject-edit', data);
  }
}

// 导出单例实例
export const imageGenerationApi = new ImageGenerationApi();